import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

function ExpandableListView(props) {
  return (
    <>
      {props.items}
      {props.showButton &&
        <div className="flex-container column center my-4">
          <button
            type="button"
            className="clickable"
            onClick={props.onExpand}
          >
            <Translate value={props.buttonLabel}/>
          </button>
        </div>
      }
    </>
  );
}

ExpandableListView.propTypes = {
  items: PropTypes.array.isRequired,
  onExpand: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  showButton: PropTypes.bool.isRequired
};

export default ExpandableListView;
